'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../../builder');
const Translator = require('./../../../../core/translator');

let ElementClass = require('./../../elementClass');

let tpl = require('./template/index.hbs');

FormBuilder.register('containerWidth', function(config) {
    let self = {};
    let currentClass = config.value || 'container';
    let onChange = config.onChange || jQuery.noop;

    self = new ElementClass(config);

    self.render = function($wrap) {
        $wrap.append(tpl());

        let $label = $wrap.find('.cloud-label');
        if (config.label) {
            $label.text(Translator.translate(config.label));
        }

        if(currentClass) {
            $wrap.find('[data-class="'+ currentClass +'"]').addClass('selected');
        }

        $wrap.find('.btn').click(function(event, ...args) {
            let $button = jQuery(event.currentTarget);

            $button.addClass('selected').siblings().removeClass('selected');

            currentClass = $button.data('class');

            onChange.call(this, currentClass, event, ...args);
        });
    };

    self.getData = function() {
        return currentClass;
    };

    return self;
});
